/** @module csi/table/PdfController */
define([
	"dojo/_base/declare",
	"csi/view/PdfController",
], function(declare, PdfController) {

	return declare(PdfController, {

		/**
		 * Refresh data if NewlyCreated group exists
		 */
		onPreActionDeferreds: function(dfds) {
			dfds.push(this.widget.refreshDataIfNewlyCreated());
		}
	});
});
